import axios from "axios";
import { baseUrl } from "../config/app.config";

export const sendNotification = async (message, phoneNumber) => {
  var result = {};

  try {
    var response = await axios.get(
      "http://13.91.248.137/textcmpgn/api/smssvc/sendsms?phone=" +
        phoneNumber +
        "&msg=" +
        message,
      { headers: { noheaders: "nil" } }
    );

    result = response.data;
  } catch (e) {
    result.error = true;
    result.data = "An error occured while processing your request";
  }

  return result;
};

export const getContactsToNotify = async (area, team, office, reportName) => {
  var result = {};
  try {
    var response = await axios.get(
      baseUrl +
        "/api/Notifications/GetContactDetailsForNotification?area=" +
        area +
        "&team=" +
        team +
        "&office=" +
        office +
        "&reportName=" +
        reportName
    );

    result.data = response.data;
  } catch (e) {
    result.error = true;
    result.data = null;
  }
  return result.data;
};
